function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function t(e) {
  return (t = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  })(e);
}

function e(t, e) {
  for (var r = 0; r < e.length; r++) {
    var o = e[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
  }
}

function r(t) {
  return function (t) {
    if (Array.isArray(t)) {
      for (var e = 0, r = new Array(t.length); e < t.length; e++) {
        r[e] = t[e];
      }

      return r;
    }
  }(t) || function (t) {
    if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
  }(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}

function o(t) {
  return (t.icon.color || "blue") + (t.icon.glyph ? n(t.icon.glyph) : t.icon.content ? "Stretchy" : "");
}

function n(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}

function a(t) {
  return t.map(function (t) {
    return Array.isArray(t) ? a(t) : +t;
  });
}

function i(e, r) {
  var o = [];
  return function e(r, n) {
    if (r === n) return !0;
    if (r instanceof Date && n instanceof Date) return +r == +n;
    if ("object" !== t(r) || "object" !== t(n)) return !1;
    if (function (t, e) {
      for (var r = o.length; r--;) {
        if (!(o[r][0] !== t && o[r][0] !== e || o[r][1] !== e && o[r][1] !== t)) return !0;
      }

      return !1;
    }(r, n)) return !0;
    o.push([r, n]);
    var a = Object.keys(r),
        i = a.length;
    if (Object.keys(n).length !== i) return !1;

    for (; i--;) {
      if (!e(r[a[i]], n[a[i]])) return !1;
    }

    return !0;
  }(e, r);
}

function s(t, e, r) {
  i(t, e) || (r.rerender && clearTimeout(r.rerender), r.rerender = setTimeout(function () {
    return r.updateMap && r.updateMap();
  }, 10));
}

var c = new (function () {
  function t() {
    !function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, t), this.events = {}, this.ymapReady = !1, this.scriptIsNotAttached = !0;
  }

  var r, o, n;
  return r = t, (o = [{
    key: "$on",
    value: function value(t, e) {
      var r = this;
      return this.events[t] || (this.events[t] = []), this.events[t].push(e), function () {
        r.events[t] = r.events[t].filter(function (t) {
          return e !== t;
        });
      };
    }
  }, {
    key: "$emit",
    value: function value(t, e) {
      var r = this.events[t];
      r && r.forEach(function (t) {
        return t(e);
      });
    }
  }]) && e(r.prototype, o), n && e(r, n), t;
}())(),
    l = ["fullscreenControl", "geolocationControl", "routeEditor", "rulerControl", "searchControl", "trafficControl", "typeSelector", "zoomControl", "routePanelControl"];

function u(t) {
  return 0 === t.filter(function (t) {
    return ![].concat(l, ["default"]).includes(t);
  }).length;
}

function p(t, e) {
  var r = n(t);
  if (!e) return r;

  switch (r) {
    case "Placemark":
      return "Point";

    case "Polyline":
      return "LineString";

    default:
      return r;
  }
}

function m(e, r) {
  var o = r ? {
    type: "Feature",
    id: e.properties.markerId,
    geometry: {
      type: e.markerType,
      coordinates: e.coords
    },
    properties: e.properties,
    options: e.options
  } : new ymaps[e.markerType](e.coords, e.properties, e.options);
  return o.clusterName = e.clusterName, r || function (e, r) {
    if (e && "object" === t(e)) for (var o in e) {
      r.events.add(o, e[o]);
    }
  }(e.callbacks, o), o;
}

var f = {
  pluginOptions: {},
  data: function data() {
    return {
      ymapEventBus: c,
      ymapId: "yandexMap" + Math.round(1e5 * Math.random()),
      myMap: {},
      style: this.ymapClass ? "" : "width: 100%; height: 100%;"
    };
  },
  props: {
    coords: {
      type: Array,
      validator: function validator(t) {
        return !t.filter(function (t) {
          return isNaN(t);
        }).length;
      },
      required: !0
    },
    zoom: {
      validator: function validator(t) {
        return !isNaN(t);
      },
      "default": 18
    },
    clusterOptions: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    clusterCallbacks: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    behaviors: {
      type: Array,
      "default": function _default() {
        return ["default"];
      }
    },
    controls: {
      type: Array,
      "default": function _default() {
        return ["default"];
      },
      validator: function validator(t) {
        return u(t);
      }
    },
    detailedControls: {
      type: Object,
      validator: function validator(t) {
        return u(Object.keys(t));
      }
    },
    scrollZoom: {
      type: Boolean,
      "default": !0
    },
    zoomControl: Object,
    mapType: {
      type: String,
      "default": "map",
      validator: function validator(t) {
        return ["map", "satellite", "hybrid"].includes(t);
      }
    },
    placemarks: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    useObjectManager: {
      type: Boolean,
      "default": !1
    },
    objectManagerClusterize: {
      type: Boolean,
      "default": !0
    },
    ymapClass: String,
    initWithoutMarkers: {
      type: Boolean,
      "default": !0
    },
    mapLink: String,
    debug: {
      type: Boolean,
      "default": !1
    },
    settings: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  computed: {
    coordinates: function coordinates() {
      return this.coords.map(function (t) {
        return +t;
      });
    }
  },
  methods: {
    getMarkersFromSlots: function getMarkersFromSlots() {
      return this.$slots["default"] && this.$slots["default"].map(function (t) {
        var e = t.componentOptions && t.componentOptions.propsData;

        if (e) {
          var r = {};
          if (e.balloonTemplate) r = {
            balloonContentLayout: ymaps.templateLayoutFactory.createClass(e.balloonTemplate)
          };
          var o = {
            markerId: e.markerId,
            markerType: e.markerType,
            coords: a(e.coords),
            hintContent: e.hintContent,
            markerFill: e.markerFill,
            circleRadius: +e.circleRadius,
            clusterName: e.clusterName,
            markerStroke: e.markerStroke,
            balloon: e.balloon,
            callbacks: e.callbacks,
            properties: e.properties,
            options: e.options,
            balloonOptions: r
          };
          return e.icon && "default#image" === e.icon.layout ? (o.iconLayout = e.icon.layout, o.iconImageHref = e.icon.imageHref, o.iconImageSize = e.icon.imageSize, o.iconImageOffset = e.icon.imageOffset) : o.icon = e.icon, o;
        }
      }).filter(function (t) {
        return t && t.markerType;
      }) || [];
    },
    createMarkers: function createMarkers() {
      for (var t = this, e = [], r = this.getMarkersFromSlots(), n = 0; n < r.length; n++) {
        var a = r[n],
            i = p(a.markerType, this.useObjectManager),
            s = {
          hintContent: a.hintContent,
          iconContent: a.icon && a.icon.content,
          markerId: a.markerId
        },
            c = a.balloon ? {
          balloonContentHeader: a.balloon.header,
          balloonContentBody: a.balloon.body,
          balloonContentFooter: a.balloon.footer
        } : {},
            l = Object.assign(s, c, a.properties),
            u = a.iconLayout ? {
          iconLayout: a.iconLayout,
          iconImageHref: a.iconImageHref,
          iconImageSize: a.iconImageSize,
          iconImageOffset: a.iconImageOffset
        } : {
          preset: a.icon && "islands#".concat(o(a), "Icon")
        },
            f = a.markerStroke ? {
          strokeColor: a.markerStroke.color || "0066ffff",
          strokeOpacity: parseFloat(a.markerStroke.opacity) >= 0 ? parseFloat(a.markerStroke.opacity) : 1,
          strokeStyle: a.markerStroke.style,
          strokeWidth: parseFloat(a.markerStroke.width) >= 0 ? parseFloat(a.markerStroke.width) : 1
        } : {},
            d = a.markerFill ? {
          fill: a.markerFill.enabled || !0,
          fillColor: a.markerFill.color || "0066ff99",
          fillOpacity: parseFloat(a.markerFill.opacity) >= 0 ? parseFloat(a.markerFill.opacity) : 1,
          fillImageHref: a.markerFill.imageHref || ""
        } : {},
            y = Object.assign(u, f, d, a.balloonOptions, a.options);
        "Circle" === i && (a.coords = [a.coords, a.circleRadius]);
        var h = m({
          properties: l,
          options: y,
          markerType: i,
          coords: a.coords,
          clusterName: a.clusterName,
          callbacks: a.callbacks
        }, this.useObjectManager);
        e.push(h);
      }

      return this.placemarks && this.placemarks.forEach(function (r) {
        var o = r.markerType,
            n = void 0 === o ? "Placemark" : o,
            a = r.properties,
            i = r.options,
            s = void 0 === i ? {} : i,
            c = r.coords,
            l = r.clusterName,
            u = r.callbacks,
            f = r.balloonTemplate,
            d = p(n, t.useObjectManager);

        if (f) {
          var y = ymaps.templateLayoutFactory.createClass(f);
          s.balloonContentLayout = y;
        }

        var h = m({
          properties: a,
          options: s,
          markerType: d,
          coords: c,
          clusterName: l,
          callbacks: u
        }, t.useObjectManager);
        e.push(h);
      }), e;
    },
    setMarkers: function setMarkers() {
      var t = {
        options: this.clusterOptions,
        callbacks: this.clusterCallbacks,
        map: this.myMap,
        useObjectManager: this.useObjectManager,
        objectManagerClusterize: this.objectManagerClusterize
      };
      !function (t, e) {
        var o = e.options,
            n = e.callbacks,
            a = e.map,
            i = e.useObjectManager,
            s = e.objectManagerClusterize,
            c = {},
            l = [],
            u = !0,
            p = !1,
            m = void 0;

        try {
          for (var f, d = t[Symbol.iterator](); !(u = (f = d.next()).done); u = !0) {
            var y = f.value;
            y.clusterName ? c[y.clusterName] = c[y.clusterName] ? [].concat(r(c[y.clusterName]), [y]) : [y] : l.push(y);
          }
        } catch (t) {
          p = !0, m = t;
        } finally {
          try {
            u || null == d["return"] || d["return"]();
          } finally {
            if (p) throw m;
          }
        }

        for (var h in c) {
          var b = o[h] || {},
              v = n[h] || {},
              k = b.layout || "\n      <div>{{ properties.balloonContentHeader }}</div>\n      <div>{{ properties.balloonContentBody }}</div>\n      <div>{{ properties.balloonContentFooter }}</div>\n    ";

          if (b.clusterBalloonItemContentLayout = ymaps.templateLayoutFactory.createClass(k), i) {
            var g = new ymaps.ObjectManager(Object.assign({
              clusterize: s
            }, b));

            for (var O in v) {
              g.clusters.events.add(O, v[O]);
            }

            g.add(c[h]), a.geoObjects.add(g);
          } else {
            var C = new ymaps.Clusterer(b);

            for (var M in v) {
              C.events.add(M, v[M]);
            }

            C.add(c[h]), a.geoObjects.add(C);
          }
        }

        if (l.length) {
          var j = i ? new ymaps.ObjectManager({
            clusterize: !1
          }) : new ymaps.GeoObjectCollection();
          l.forEach(function (t) {
            return j.add(t);
          }), a.geoObjects.add(j);
        }
      }(this.createMarkers(), t);
    },
    init: function init() {
      var t = this;

      if (window.ymaps && ymaps.GeoObjectCollection && (this.initWithoutMarkers || this.$slots["default"] || this.placemarks.length)) {
        if (this.$emit("map-initialization-started"), this.myMap = new ymaps.Map(this.ymapId, {
          center: this.coordinates,
          zoom: +this.zoom,
          behaviors: this.behaviors,
          controls: this.controls,
          type: "yandex#".concat(this.mapType)
        }, this.options), this.myMap.events.add("click", function (e) {
          return t.$emit("click", e);
        }), this.zoomControl && (this.myMap.controls.remove("zoomControl"), this.myMap.controls.add(new ymaps.control.ZoomControl(this.zoomControl))), this.detailedControls) Object.keys(this.detailedControls).forEach(function (e) {
          t.myMap.controls.remove(e), t.myMap.controls.add(e, t.detailedControls[e]);
        });
        !1 === this.scrollZoom && this.myMap.behaviors.disable("scrollZoom"), this.setMarkers(), this.$emit("map-was-initialized", this.myMap);
      }
    }
  },
  watch: {
    coordinates: function coordinates(t) {
      this.myMap.panTo && this.myMap.panTo(t);
    },
    placemarks: function placemarks() {
      window.ymaps && (this.myMap.geoObjects && this.myMap.geoObjects.removeAll(), this.setMarkers());
    },
    zoom: function zoom() {
      this.myMap.setZoom(this.zoom);
    }
  },
  render: function render(t) {
    return t("section", {
      "class": "ymap-container",
      ref: "mapContainer"
    }, [t("div", {
      attrs: {
        id: this.ymapId,
        "class": this.ymapClass,
        style: this.style
      }
    }), t("div", {
      ref: "markersContainer",
      attrs: {
        "class": "ymap-markers"
      }
    }, [this.$slots["default"]])]);
  },
  mounted: function mounted() {
    var t = this;
    this.markerObserver = new MutationObserver(function () {
      this.myMap.geoObjects && this.myMap.geoObjects.removeAll(), this.setMarkers();
    }.bind(this)), this.mapObserver = new MutationObserver(function () {
      this.myMap.container.fitToViewport();
    }.bind(this));
    var e = this.$refs,
        r = e.markersContainer,
        o = e.mapContainer;

    if (this.markerObserver.observe(r, {
      attributes: !0,
      childList: !0,
      characterData: !0,
      subtree: !0
    }), this.mapObserver.observe(o, {
      attributes: !0,
      childList: !0,
      characterData: !0,
      subtree: !1
    }), this.ymapEventBus.scriptIsNotAttached) {
      var n = document.createElement("SCRIPT"),
          a = Object.assign({}, this.$options.pluginOptions, this.settings),
          i = a.apiKey,
          s = void 0 === i ? "" : i,
          c = a.lang,
          l = void 0 === c ? "ru_RU" : c,
          u = a.version,
          p = void 0 === u ? "2.1" : u,
          m = this.debug ? "debug" : "release",
          f = this.mapLink || "https://api-maps.yandex.ru/".concat(p, "/?lang=").concat(l).concat(s && "&apikey=".concat(s), "&mode=").concat(m);
      n.setAttribute("src", f), n.setAttribute("async", ""), n.setAttribute("defer", ""), document.body.appendChild(n), this.ymapEventBus.scriptIsNotAttached = !1, n.onload = function () {
        t.ymapEventBus.ymapReady = !0, t.ymapEventBus.$emit("scriptIsLoaded");
      };
    }

    this.ymapEventBus.ymapReady ? ymaps.ready(this.init) : this.ymapEventBus.$on("scriptIsLoaded", function () {
      t.ymapEventBus.updateMap = function () {
        t.myMap.geoObjects && t.myMap.geoObjects.removeAll(), t.setMarkers();
      }, ymaps.ready(t.init);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.myMap.geoObjects && this.myMap.geoObjects.removeAll(), this.markerObserver.disconnect();
  }
},
    d = {
  data: function data() {
    return {
      ymapEventBus: c,
      unwatchArr: []
    };
  },
  props: {
    coords: {
      type: Array,
      required: !0
    },
    hintContent: String,
    icon: Object,
    balloon: Object,
    markerType: {
      type: String,
      required: !0
    },
    markerFill: Object,
    markerStroke: Object,
    clusterName: String,
    circleRadius: {
      validator: function validator(t) {
        return !isNaN(t);
      },
      "default": 1e3
    },
    callbacks: Object,
    balloonTemplate: String,
    markerId: {
      type: [String, Number],
      required: !0
    },
    properties: Object,
    options: Object
  },
  render: function render() {},
  mounted: function mounted() {
    var t = this;

    for (var e in this.$props) {
      this.unwatchArr.push(this.$watch(e, function (e, r) {
        return s(e, r, t.ymapEventBus);
      }));
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unwatchArr.forEach(function (t) {
      return t();
    });
  }
};
f.install = function (t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  f.pluginOptions = e, t.component("yandex-map", f), t.component("ymap-marker", d);
}, "undefined" != typeof window && window.Vue && window.Vue.use(f);
var y = f,
    h = d;
export default f;
export { y as yandexMap, h as ymapMarker };